import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {ModalidadeScrRoutingModule} from './modalidade-scr-routing.module';
import {ModalidadeScrPesquisa} from './pequisa/modalidade-scr-pesquisa';
import {ModalidadeScrListagem} from './listagem/modalidade-scr-listagem';
import {ModalidadeScrCadastroComponent} from './cadastro/modalidade-scr-cadastro.component';
import {HabilitacaoScrComponent} from './habilitacao-scr/habilitacao-scr.component';

@NgModule({
  declarations: [
    ModalidadeScrPesquisa,
    ModalidadeScrListagem,
    ModalidadeScrCadastroComponent,
    HabilitacaoScrComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    NgSelectModule,
    ModalidadeScrRoutingModule,
  ],
  providers: []
})
export class ModalidadeScrModule {
}
